<template>
  <div class="overlay" :class="{ open: isMenuOpen }">
    <div class="content-wrapper">
      <div class="shop-context">
        <img :src="shop.thumbnail" alt="" />
        <div class="shop-info">
          <span class="shop-name"> {{ shop.name }} </span>
          <span class="subtitle"> Artist</span>
        </div>
      </div>
      <ul class="action-menu">
        <!-- <li>
          <button class="action" @click="toggleFollow">
            <svg
              role="img"
              focusable="false"
              height="24"
              width="24"
              viewBox="0 0 24 24"
            >
              <circle
                cx="17.5"
                cy="19"
                r="2.5"
                fill="none"
                stroke="white"
              ></circle>
              <polyline
                points="22.87 12.51 20 10.7 20 19"
                fill="none"
                stroke="white"
              ></polyline>
              <path
                d="M15.52 15.29l-.69-.39a1 1 0 01-.32-1.63l.53-.56.13-.13A5.72 5.72 0 0017 8.51 5.27 5.27 0 0012 3a5.27 5.27 0 00-5 5.51 5.72 5.72 0 001.83 4.06l.13.13.53.56a1 1 0 01-.32 1.63L6 16.7a5 5 0 00-1.87 1.84 5.53 5.53 0 00-.65 2.94V22"
                fill="none"
                stroke="white"
              ></path>
            </svg>
            <span>Follow</span>
          </button>
        </li> -->
        <li>
          <button class="action" @click="goToShop">
            <svg
              role="img"
              focusable="false"
              height="24"
              width="24"
              viewBox="0 0 24 24"
            >
              <circle
                cx="17.5"
                cy="19"
                r="2.5"
                fill="none"
                stroke="white"
              ></circle>
              <polyline
                points="22.87 12.51 20 10.7 20 19"
                fill="none"
                stroke="white"
              ></polyline>
              <path
                d="M15.52 15.29l-.69-.39a1 1 0 01-.32-1.63l.53-.56.13-.13A5.72 5.72 0 0017 8.51 5.27 5.27 0 0012 3a5.27 5.27 0 00-5 5.51 5.72 5.72 0 001.83 4.06l.13.13.53.56a1 1 0 01-.32 1.63L6 16.7a5 5 0 00-1.87 1.84 5.53 5.53 0 00-.65 2.94V22"
                fill="none"
                stroke="white"
              ></path>
            </svg>
            <span>Visit Shop</span>
          </button>
        </li>
      </ul>
    </div>
    <button class="cancel-btn" @click="close">
      <span class="button-title">Cancel</span>
    </button>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "MobileOverlay",
  components: {},
  data() {
    return {
      shop: {},
    };
  },
  computed: {
    ...mapGetters({
      isMenuOpen: "menu/isMenuOpen",
    }),
  },
  watch: {
    "$store.state.menu.overlayShop": function () {
      this.shop = this.$store.state.menu.overlayShop;
    },
  },
  methods: {
    close() {
      this.closeMenu();
      this.trackEvent(
        "Navigation",
        "Close Modal",
        this.shop.name,
        this.shop.id
      );
    },
    toggleFollow() {},
    goToShop() {
      this.closeMenu();
      this.$router.push(`/shop/${this.shop.id}`);
    },
  },
};
</script>

<style lang="scss" scoped>
.action-menu {
  padding: 0px;
  margin-top: 26px;
  list-style: none;
  .action {
    display: flex;
    padding: 16px 0px;
    width: 100%;
    color: rgb(255, 255, 255);
    align-items: center;
    background: transparent;
    border: 0px;
    transition: background-color 0.2s ease 0s;
    touch-action: manipulation;
    svg {
      margin-right: 16px;
    }
    span {
      font-size: 16px;
      font-weight: 500;
      line-height: 24px;
      margin-top: 2px;
    }
  }
}

.overlay {
  height: 0;
  width: 100%;
  position: fixed;
  z-index: 99999;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.95);
  overflow-y: hidden;
  transition: 0.2s;
  display: flex;
  flex-direction: column;
  &.open {
    height: 100%;
  }
  .content-wrapper {
    padding: 88px 16px 16px;
    flex-grow: 1;
    overflow-y: scroll;
    .shop-context {
      align-self: center;
      display: flex;
      flex-direction: row;
      align-items: center;
      img {
        width: 64px;
        height: 64px;
        margin-right: 16px;
        object-fit: cover;
      }
    }
    .shop-info {
      flex: 1 1 0%;
      flex-direction: column;
      align-self: center;
      display: flex;
      .shop-name {
        font-size: 18px;
        font-weight: 700;
        text-align: start;
      }
      .subtitle {
        font-size: 13px;
        font-weight: 400;
        line-height: 16px;
        color: rgb(179, 179, 179);
        text-align: start;
      }
    }
  }
  .cancel-btn {
    padding: 14px 16px 24px;
    box-shadow: rgb(0 0 0 / 90%) 0px -9px 13px 11px;
    z-index: 1;
    background: transparent;
    border: 0px;
    transition: background-color 0.2s ease 0s;
    touch-action: manipulation;
    span {
      font-size: 18px;
      font-weight: 700;
      text-align: start;
      color: white;
    }
  }
}
</style>
